
	import { Component, Vue } from 'vue-property-decorator';
	import Tick from '@/components/Tick.vue';
	import Loading from '@/components/Loading.vue';
	import Modal from '@/components/Modal.vue';
	import ErrorModal from '@/components/ErrorModal.vue';
	import AgentConnectionError from '@/components/AgentConnectionError.vue';
	import Fitstation3DScan from '@/components/Fitstation3DScan/Fitstation3DScan.vue';
	import CustomModal from '@/components/CustomModal.vue';
	import LeftFootSVG from '@/components/LeftFootSVG.vue';
	import RightFootSVG from '@/components/RightFootSVG.vue';
	import NotesButton from '@/components/NotesButton.vue';
	import FootScanner, { ScanState } from '@/components/FootScanner.vue';
	import DualButtonModal from '@/components/modals/DualButtonModal.vue';
	import { Observer } from 'mobx-vue';
	import errorMessages from '@/assets/error-messages.json';
	import HPAgentModule from '@/store/engine/modules/HPAgentModule';

	@Observer
	@Component({
		components: {
			DualButtonModal,
			FootScanner,
			NotesButton,
			RightFootSVG,
			LeftFootSVG,
			CustomModal,
			Fitstation3DScan,
			AgentConnectionError,
			ErrorModal,
			Loading,
			Tick,
			Modal
		}
	})
	export default class ThreeDScan extends Vue {
		private errorMsg: string = 'Scanner is not working. Please check the cable and make sure your scanner is on and connected to your PC.';
		private agentConnectionError = false;
		private disconnectedModal = false;
		private connecting = false;
		private hideLoading = false;
		private componentLoading = true;
		private leftScanState: any = ScanState.CHECKING;
		private rightScanState: any = ScanState.CHECKING;
		private buttonsDisabled = false;
		private noHealthyDevicesModal = false;
		private tabletDetected = false;
		private lostConnectionWhileScanning = false;
		private errorMessages: any;
		private healthErrorMessage: string = '';
		private websocketError = false;
		private timeoutModal = false;
		private aboveFiveSeconds = false;
		private clicked = false;
		private updateTimeout = 0;
		private agent: HPAgentModule = this.$state.engine.agent;
		private showScanDisconnectedError = false;
		private disableRestartScannerButton = true;

		private handleDisconnectCable() {
			// this.$router.push('threed/?id=fd29102b-cd64-4431-af99-40630679403a');
			// this.$router.go();
			this.disableRestartScannerButton = true;
			setTimeout(() => {
				this.$router.push(`threed?id=${this.$state._patient.userRecordID}`);
				// this.$router.go(); // TODO do we need this?
			}, 3000);
			// this.$router.push('patients');
		}

		private rescanEvent() {
			window.dispatchEvent(new CustomEvent('requestForRescan'));
			this.showScanDisconnectedError = false;
		}

		private scanButtonDisabled(state: any) {
			state = ScanState[state];
			return state != ScanState.RENDERED && state != ScanState.NOT_FOUND && state != ScanState.SCANNING_ERROR;
		}

		public leftStateChaneged(val) {
			this.leftScanState = ScanState[val];
			this.buttonsDisabled = this.scanButtonDisabled(this.leftScanState) || this.scanButtonDisabled(this.rightScanState);
		}

		public rightStateChanged(val) {
			this.rightScanState = ScanState[val];
			this.buttonsDisabled = this.scanButtonDisabled(this.leftScanState) || this.scanButtonDisabled(this.rightScanState);
		}

		private restart() {
			this.$router.push('patients');
			location.reload();
		}

		handleLostConnection() {
			this.lostConnectionWhileScanning = false;
		}

		clearScan(side: string) {
			this[side + 'ScanState'] = ScanState[ScanState.NOT_FOUND];
		}

		private handleRefreshToken(e) {
			if (e.detail.error !== '') {
				this.agentConnectionError = true;
			}
		}

		public async created() {
			this.errorMessages = errorMessages;
			window['clicked'] = this.clicked;
			window.addEventListener('OnDeviceDetached', async (e) => {
				window.dispatchEvent(new CustomEvent('scannerDetached'));

				// this.agentConnectionError = true;
			});

			window.addEventListener('RefreshTokenResults', this.handleRefreshToken);

			window.addEventListener('socketError', async (e) => {
				this.websocketError = true;
			});

			window.addEventListener('agentDisconnected', async (e) => {
				this.agentConnectionError = true;
			});

			window.addEventListener('OnDeviceAvailable', async (e) => {
				await this.setupDevice();
			});

			window.addEventListener('OnDeviceAttached', async (e) => {
				await this.setupDevice();
			});

			window.addEventListener('scannerDetached', async () => {
				// this.scanState = ScanState.SCANNING_ERROR;
				this.showScanDisconnectedError = true;
				this.clearScan('right');
				this.clearScan('left');
				await this.$state.engine.agent.disconnect();
				await this.$state.engine.agent.open();
			});

			if (this.$state.utils.isIPad()) {
				this.tabletDetected = true;
				return;
			}

			if (this.agent.agentStatus === 0) {
				// disocnected
				this.connectToHPAgent();
			}
		}

		public async activated() {
			this.clicked = false;

			// need to cache that
			await this.setLastValidScanningSession();

			const health = this.agent.healthCheck();
			const timeout = new Promise((resolve) => setTimeout(resolve, 5000, 'timeout'));
			const resolve: any = await Promise.race([health, timeout]);

			if (resolve === 'timeout') {
				this.timeoutModal = true;
			} else if (resolve.status && resolve.status === 'ERROR') {
				console.log(resolve, 'HEALTH');
				this.healthErrorMessage = resolve.error;
				this.noHealthyDevicesModal = true;
			}

			this.setupDevice();
		}

		public async setupDevice() {
			if (this.agent.agentStatus === 0) {
				// disocnected
				await this.connectToHPAgent();
				return;
			}

			//addational time for agent to get devices
			await new Promise((r) => {
				setTimeout(r, 1000);
			});

			this.noHealthyDevicesModal = false;

			if (this.agent.devices.length === 0) {
				this.noHealthyDevicesModal = true;
				this.healthErrorMessage = errorMessages.noHealthyDevices.text;
				return;
			}

			this.disconnectedModal = false;

			const nonMocks = this.agent.devices.filter((device) => {
				return !device.model_id.includes('MOCK');
			});

			if (nonMocks.length > 0) {
				const tiger = this.agent.devices.find((device) => device.model_id.includes('TIGER'));
				this.agentConnectionError = false;

				if (tiger) {
					await this.$state.agent.setCurrentDevice(tiger);
					return;
				}

				await this.$state.agent.setCurrentDevice(nonMocks[0]);
			} else {
				this.agentConnectionError = false;
				await this.$state.agent.setCurrentDevice(this.agent.devices[0]);
			}
		}

		public async mounted() {
			console.log();
			window.addEventListener('beforeunload', async (e) => {
				if (this.$route.name == '3D Scan' && (this.leftScanState == ScanState[2] || this.rightScanState == ScanState[2])) {
					e.preventDefault();
					e.returnValue = true;
				}
			});
			this.buttonsDisabled = this.scanButtonDisabled(this.leftScanState) || this.scanButtonDisabled(this.rightScanState);
			this.hideLoading = true;
			this.componentLoading = true;

			setTimeout(() => {
				this.hideLoading = false;
			}, 1750);

			setTimeout(() => (this.componentLoading = false), 1000);
		}

		public async connectToHPAgent() {
			this.aboveFiveSeconds = false;
			setTimeout(() => {
				this.aboveFiveSeconds = true;
			}, 5000);
			this.disconnectedModal = false;
			this.connecting = true;

			const opened = await this.agent.open();

			if (opened) {
				this.connecting = false;
				await this.setLastValidScanningSession();
				await this.setupDevice();
				this.agentConnectionError = false;
			} else {
				this.connecting = false;
				this.agentConnectionError = true;
			}
		}

		private async updateLastValidSession() {
			clearTimeout(this.updateTimeout);
			this.updateTimeout = setTimeout(async () => {
				if (!this.$state._patient.userRecordID || !this.$state._patient.currentSessionID) {
					return;
				} else {
					const profile = await this.$engine.profile;
					const updateSession = await profile.updateFitStationProfile(this.$state._patient.userRecordID, {
						lastValidScanningSession: this.$state._patient.currentSessionID
					});
					if (this.$state._patient.patient) {
						this.$state._patient.patient.fitstationProfile = await this.$state._patient.getFitstationProfile(this.$state._patient.userRecordID);
					}
				}
			}, 500);
		}

		public async setLastValidScanningSession() {
			const lastValidScanningSession = this.$state._patient.patient?.fitstationProfile?.data?.lastValidScanningSession;
			if (lastValidScanningSession) {
				await this.$state.engine.agent.setLastValidScanningSession(lastValidScanningSession);
			}
		}

		public async confirmation() {
			if (this.$route.name == '3D Scan' && (this.leftScanState == ScanState[2] || this.rightScanState == ScanState[2])) {
				const confirmation = confirm('You are in middle of the scan, are u sure you want to leave? Your scan might not be saved');
				return confirmation;
			}
			return true;
		}

		public handleScannerError(error: string) {
			const getErrorMessage = () => {
				switch (error) {
					case 'Scanner is not ready': {
						return this.errorMessages.scannerError.scannerNotReady;
					}
					case 'Scan Failed': {
						this.showScanDisconnectedError = true;
						setTimeout(() => {
							this.disableRestartScannerButton = false;
						}, 2000);
						break;
						// return this.errorMessages.scannerError.scanFailed;
					}
					case 'Upload Failed': {
						return this.errorMessages.scannerError.uploadFailed;
					}
					default: {
						return this.errorMessages.scannerError.default;
					}
				}
			};
			this.errorMsg = getErrorMessage();
			if (error == 'Cannot start scan.') {
				return; // we have other modal for this error
			}
			this.disconnectedModal = true;
		}

		public async next() {
			const confirmation = await this.confirmation();
			if (confirmation) {
				await this.$router.push('landmarks');
			}
		}

		public async patients() {
			const confirmation = await this.confirmation();

			if (confirmation) {
				await this.$router.push('patients');
			}
		}

		public async prev() {
			const confirmation = await this.confirmation();
			if (confirmation) {
				await this.$router.push('scan-settings');
			}
		}
	}
